module.exports = __webpack_public_path__ + "static/preview-noah-ddc86fb32a660f4cc98ffad6d1412446.wav";